import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/invoiceManage',
    meta: { title: '发票管理' },
    component: Layout,
    redirect: '/invoiceManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '发票管理', activeMenu: '/invoiceManage' },
        component: () => import('@/views/invoiceManage/Index.vue')
      },
      {
        path: 'detail',
        meta: { title: '发票详情', activeMenu: '/invoiceManage' },
        component: () => import('@/views/invoiceManage/InvoiceManageDetail.vue')
      }

    ]
  }

]
